<div class="wrapper" [ngClass]="{ 'is-safari': isSafari }">
  <mat-sidenav-container (backdropClick)="sidenavStateChange()">
    <mat-sidenav [(opened)]="sidenav.isSidenavOpen">
      <rdx-mobile-sidenav #sidenav />
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet />
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
